'use strict';
module.exports = function(app) {
    app.factory('syncDisPlayProductFactory', function () {
        return {
            getStartedProduct: function (response) {
                var product = response.filter(function (p) {
                    return p.started === true;
                })[0];

                if (product) {
                    return product;
                } else if (typeof product === 'undefined') {
                    //if there is no product started make first product appear
                    return response[0];
                }
            }
        };
    });
};



/*****************
 ** WEBPACK FOOTER
 ** ./shared/js/factory/sync_display_product.factory.js
 ** module id = 83
 ** module chunks = 0
 **/